import { Module, VuexModule, Action, Mutation } from "vuex-module-decorators";
import { store } from "commonui";
import { CategoryResponseModel, CategoryManagerService } from "@/services/category-manager";
import { ILessonPlanVersionModel } from "@/models/lesson-plan";
import { IVersionGroupService, VersionGroupModel, VersionGroupService } from "@/services/version-group";
import { VersionGroupModule } from "./versiongroup";
import { ILessonPlanVersionService, LessonPlanVersionService } from "@/services/lesson-plan";
import { getSelectedVersionGroups } from "@/util/func";
import { LessonPlanVersionStatus, MethodologyType, MethodologyTypeEnum } from "@/util/enum";
import { TitleListService } from "@/services";
import { VCSLevelModel } from "@/models/title-list-model";

@Module({ namespaced: true, name: "CategoryManagerState", store: store, dynamic: true })
export default class CategoryManagerState extends VuexModule {
	categories: CategoryResponseModel[] = [];
	lessonPlanVersions: ILessonPlanVersionModel[] = [];
	versionGroupService: IVersionGroupService = VersionGroupService();
	lessonPlanVersionService: ILessonPlanVersionService = LessonPlanVersionService();
	vcsUnits: VCSLevelModel[] = [];

	@Mutation
	setVCSLevelUnits(units: VCSLevelModel[]) {
		this.vcsUnits = units;
	}

	@Action
	async getVCSLevelUnits() {
		const units = await TitleListService.getLevels([], true);
		this.setVCSLevelUnits(units);
	}

	@Mutation
	setCategories(cats: CategoryResponseModel[]) {
		this.categories = cats;
	}

	@Mutation
	setLessonPlanVersions(lpVersions: ILessonPlanVersionModel[]) {
		this.lessonPlanVersions = lpVersions;
	}

	@Action
	async fetchCategories() {
		const cats = await CategoryManagerService().getCategories();
		this.setCategories(cats);
	}

	@Action
	async fetchLessonPlanVersionsOfCurrentVersionGroup() {
		const versionGroups: VersionGroupModel[] = VersionGroupModule.versionGroups;
		const { selectedGSVersion, selectedLSVersion } =
			VersionGroupModule.selectedGsVersion === "-1" && VersionGroupModule.selectedLsVersion === "-1"
				? await this.versionGroupService.getVcsSettings()
				: {
						selectedGSVersion: VersionGroupModule.selectedGsVersion,
						selectedLSVersion: VersionGroupModule.selectedLsVersion
				  };
		const selectedVersionGroups: VersionGroupModel[] = getSelectedVersionGroups(
			versionGroups,
			selectedGSVersion,
			selectedLSVersion
		);
		const allLessonPlanVersions: ILessonPlanVersionModel[] =
			selectedVersionGroups.length === 0
				? []
				: await this.lessonPlanVersionService.getLessonPlanVersionsByTypes(
						selectedVersionGroups.map((svg) => svg.id),
						[MethodologyTypeEnum.All]
				  );

		this.setLessonPlanVersions(
			allLessonPlanVersions.filter(
				(lp) =>
					lp.status &&
					(lp.status === LessonPlanVersionStatus.Published || lp.status === LessonPlanVersionStatus.Internal)
			)
		);
	}
}
